<script>
import _baseDropdownPicker from '@components/_base-dropdown-picker'

export default {
  name: 'EnumDropdownPicker',
  extends: _baseDropdownPicker,
  props: {
    unassignedValue: {
      type: [String, Object, Boolean],
      default() {
        return null
      },
    },
  },
}
</script>
